import * as types from '../../constants/ActionTypes'

export const switchCategory = category => ({
  type: types.SWITCH_CATEGORY,
  category
})
